import React, { useEffect, useState } from "react";
import axios from "axios";
import sharedStyles from '../styles/shared.module.css';
import servicosStyles from '../styles/servicos.module.css';

type Servico = {
  id: number;
  nome: string;
  descricao: string;
  icone: string;
  comissao: number;
};

const AdminServicos = () => {
  const [servicos, setServicos] = useState<Servico[]>([]);
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [icone, setIcone] = useState("");
  const [comissao, setComissao] = useState<number>(0);

  const [editId, setEditId] = useState<number | null>(null);
  const [editNome, setEditNome] = useState("");
  const [editDescricao, setEditDescricao] = useState("");
  const [editIcone, setEditIcone] = useState("");
  const [editComissao, setEditComissao] = useState<number>(0);

  const BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const fetchServicos = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/admins/servicos`, { headers });
      if (Array.isArray(response.data)) {
        setServicos(response.data);
      } else {
        setServicos([]);
      }
    } catch (err) {
      console.error("Erro ao buscar serviços:", err);
      setServicos([]);
    }
  };

  const handleAddServico = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await axios.post(
        `${BASE_URL}/admins/servicos`,
        { nome, descricao, icone, comissao },
        { headers }
      );
      setNome("");
      setDescricao("");
      setIcone("");
      setComissao(0);
      fetchServicos();
    } catch (err) {
      console.error("Erro ao adicionar serviço:", err);
    }
  };

  const handleDeleteServico = async (id: number) => {
    try {
      await axios.delete(`${BASE_URL}/admins/servicos/${id}`, { headers });
      fetchServicos();
    } catch (err) {
      console.error("Erro ao deletar serviço:", err);
    }
  };

  const handleEditClick = (servico: Servico) => {
    setEditId(servico.id);
    setEditNome(servico.nome);
    setEditDescricao(servico.descricao);
    setEditIcone(servico.icone);
    setEditComissao(servico.comissao);
  };

  const handleUpdateServico = async (id: number) => {
    try {
      await axios.put(
        `${BASE_URL}/admins/servicos/${id}`,
        { nome: editNome, descricao: editDescricao, icone: editIcone, comissao: editComissao },
        { headers }
      );
      setEditId(null);
      fetchServicos();
    } catch (err) {
      console.error("Erro ao atualizar serviço:", err);
    }
  };

  useEffect(() => {
    fetchServicos();
  }, []);

  return (
    <div className={sharedStyles.container}>
      <h1>Gerenciar Serviços</h1>

      <form
        onSubmit={handleAddServico}
        className={`${sharedStyles.form} ${servicosStyles.form}`}
      >
        <input
          type="text"
          placeholder="Nome do Serviço"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          required
        />
        <textarea
          placeholder="Descrição"
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Ícone (emoji ou URL)"
          value={icone}
          onChange={(e) => setIcone(e.target.value)}
          required
        />
        <input
          type="number"
          placeholder="Comissão (%)"
          value={comissao}
          onChange={(e) => setComissao(Number(e.target.value))}
          min={0}
          max={100}
          required
        />
        <button type="submit" className={sharedStyles.addButton}>
          ➕ Adicionar
        </button>
      </form>

      <div className={sharedStyles.list}>
        {servicos.map((servico) => (
          <div key={servico.id} className={sharedStyles.card}>
            {editId === servico.id ? (
              <div className={servicosStyles.editArea}>
                <input
                  type="text"
                  value={editNome}
                  onChange={(e) => setEditNome(e.target.value)}
                />
                <textarea
                  value={editDescricao}
                  onChange={(e) => setEditDescricao(e.target.value)}
                />
                <input
                  type="text"
                  value={editIcone}
                  onChange={(e) => setEditIcone(e.target.value)}
                />
                <input
                  type="number"
                  value={editComissao}
                  onChange={(e) => setEditComissao(Number(e.target.value))}
                  min={0}
                  max={100}
                />
                <div className={servicosStyles.editActions}>
                  <button onClick={() => handleUpdateServico(servico.id)}>
                    💾 Salvar
                  </button>
                  <button onClick={() => setEditId(null)}>❌ Cancelar</button>
                </div>
              </div>
            ) : (
              <div className={servicosStyles.cardContent}>
                <div className={servicosStyles.cardInfo}>
                  <div className={servicosStyles.icon}>{servico.icone}</div>
                  <div>
                    <strong>{servico.nome}</strong>
                    <p>{servico.descricao}</p>
                    <small>Comissão: {servico.comissao}%</small>
                  </div>
                </div>
                <div className={servicosStyles.cardActions}>
                  <button onClick={() => handleEditClick(servico)}>
                    ✏️ Editar
                  </button>
                  <button
                    onClick={() => handleDeleteServico(servico.id)}
                    className={sharedStyles.deleteButton}
                  >
                    🗑️ Deletar
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminServicos;
